import { GoogleAnalytics } from '../../../services'

export const anonymous = () => {
  try {
    // google analytics
    GoogleAnalytics.identify()
  } catch (e) {}
}
